module.exports = __webpack_public_path__ + "img/louisxiii-black.5d054d11.svg";